module.exports = __webpack_public_path__ + "img/cb9-r-101.e7effe13.gif";